import {
    CategoriaFaq,
    MacrotemaFaq,
    SottoCategoriaFaq,
    Faq,
} from '@hm_app/@core/models/info';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { Component, OnInit, Input } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { FormGroup, FormControl } from '@angular/forms';
import { environment } from '@src/environments/environment';
import { BASE_PATH_IMAGES } from '@src/environments/configs';

@Component({
    selector: 'app-faq-detail-faq',
    templateUrl: './faq-detail.component.html',
    styleUrls: ['./faq-detail.component.scss'],
})
export class FaqDetailComponent implements OnInit {

    @Input() private _faq: Faq;

    categorie: Map<number, CategoriaFaq> = new Map();
    macrotemi: Map<number, MacrotemaFaq> = new Map();
    sottocategorie: Map<number, SottoCategoriaFaq> = new Map();

    BASE_PATH: string = BASE_PATH_IMAGES;

    constructor(
        private hmService: HappyMammaService,
        private route: ActivatedRoute,
        private location: Location,
    ) {
    }

    set faq(f: Faq) {
        this._faq = f;
    }

    get faq(): Faq {
        return this._faq;
    }

    async fetchDependencies() {
        const macro = await this.hmService
            .getAll<MacrotemaFaq>(MacrotemaFaq)
            .toPromise();
        macro.forEach(d => this.macrotemi.set(d.id, d));

        const categs = await this.hmService
            .getAll<CategoriaFaq>(CategoriaFaq)
            .toPromise();
        categs.forEach(d => this.categorie.set(d.id, d));

        const subcat = await this.hmService
            .getAll<SottoCategoriaFaq>(SottoCategoriaFaq)
            .toPromise();
        subcat.forEach(d => this.sottocategorie.set(d.id, d));
    }

    set id_faq(id: number) {
        this.hmService.getInstance<Faq>(id, Faq)
            .subscribe(faq => this.faq = faq);
    }

    ngOnInit(): void {
        this.fetchDependencies();
    }

    goBack(): void {
        this.location.back();
    }
}
